module.exports = __webpack_public_path__ + "static/img/productimg2.194f1dd4.png";